import styled from 'styled-components';
import { forwardRef } from 'react';

const BadgeItem = styled.span`
    padding: 0 7px;
    height: 25px;
    color: white;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    font-family: ui-monospace, monospace;
`;

export const Badge = forwardRef((props: any, ref: any) => {
    const backgroundColor = props.backgroundColor;

    props = { ...props, backgroundColor: undefined };

    return <BadgeItem style={{ backgroundColor: backgroundColor }} {...props} ref={ref} />;
});
